import { Box } from '@mui/material'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import { useMemo } from 'react'

interface IDot {
    animationDelay: string
}

function Dot({ animationDelay }: IDot) {
    const { isMobileTablet, isLandscapeMobile } = useScreenSize()
    const size = useMemo(
        () => (isMobileTablet || isLandscapeMobile ? 10 : 15),
        [isLandscapeMobile, isMobileTablet],
    )
    return (
        <Box
            sx={{
                width: size,
                height: size,
                borderRadius: 10,
                m: 0.5,
                animation: `dot 2s linear infinite`,
                animationDelay: animationDelay,
                '@Keyframes dot': {
                    '0%': {
                        backgroundColor: 'primary.light',
                    },
                    '100%': {
                        backgroundColor: 'primary.contrastText',
                    },
                },
            }}
        />
    )
}
export default Dot
